/**
 * Convert number to two digit value string preceding 0s
 * @param {int} value number to be converted
 * @param {int} totalWidth on how many leading zeros we want
 */
const PadLeftWithLeadingZeros = (value, totalWidth) =>
    value.toLocaleString('en-US', {
        minimumIntegerDigits: totalWidth,
        useGrouping: false
    });
export default PadLeftWithLeadingZeros;
